import { useEffect, useState } from 'react';
import { getOwnSubject } from '../../Subject/services/subjectService';

export function useOwnSubject(subjectId) {
  const [subject, setSubject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');

    getOwnSubject(subjectId)
      .then((result) => {
        if (!mounted) return;
        if (!result) {
          setError('Subject not found or not assigned to you.');
          setSubject(null);
        } else {
          setSubject(result);
        }
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load subject');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [subjectId]);

  return { subject, loading, error };
}
